import React from 'react'
import styled from 'styled-components'
import { NotificationBadge } from 'blocket-ui'

const StyledNewBadge = styled(NotificationBadge)`
  position: absolute;
  top: -6px;
  right: -11px;
`

const NewBadge = () => <StyledNewBadge content="Ny" theme="blue" />

export default NewBadge
